// src/components/common/CustomDatePicker.js
import React from 'react';
import DatePicker from 'react-datepicker';
import { getMonth, getYear } from 'date-fns';
import { range } from 'lodash';
import 'react-datepicker/dist/react-datepicker.css';

const CustomDatePicker = ({ name, selectedDate, onChange, className, withPortal = true, disabled = false }) => {

    const years = range(1990, getYear(new Date()) + 1, 1);
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    return (
        <DatePicker
            className={className ? className : "form-control"}
            selected={selectedDate}
            onChange={(date) => onChange(name, date)}
            dateFormat="dd.MM.yyyy"
            showPopperArrow={false}
            disabled={disabled}
            renderCustomHeader={({
                                     date,
                                     changeYear,
                                     changeMonth,
                                     decreaseMonth,
                                     increaseMonth,
                                     prevMonthButtonDisabled,
                                     nextMonthButtonDisabled,
                                 }) => (
                <div
                    style={{
                        margin: 10,
                        display: "flex",
                        justifyContent: "center",
                        gap: 8,
                        alignItems: "center"
                    }}
                >
                    <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                        {"<"}
                    </button>
                    <select
                        value={getYear(date)}
                        onChange={({ target: { value } }) => changeYear(Number(value))}
                    >
                        {years.map((year) => (
                            <option key={year} value={year}>{year}</option>
                        ))}
                    </select>

                    <select
                        value={getMonth(date)}
                        onChange={({ target: { value } }) => changeMonth(Number(value))}
                    >
                        {months.map((month, idx) => (
                            <option key={month} value={idx}>{month}</option>
                        ))}
                    </select>

                    <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                        {">"}
                    </button>
                </div>
            )}
            isClearable
            withPortal={withPortal}
        />
    );
};

export default CustomDatePicker;
